import { MASTERMULTITOTAL } from "../../../front/js/constants/multiCinemaModes";
import getPeriodeEndDate from "./getPeriodeEndDate";

const getMoviesSortedAfterCurrentAndFuture = (order, movieData, currentMovies, futureMovies, activeWeek, currentCinemaId, performances, customWeek=false, currentClientCinemaId, multicinemaMode) => { 
    const relevantMovies = {}
    let sortedMovies
    
    _.keys(movieData).map(movieId => {
        const movie = movieData[movieId]
        if(multicinemaMode === MASTERMULTITOTAL || currentCinemaId === currentClientCinemaId) {
            relevantMovies[movieId] = movie
        } else {
            if(_.contains(movie.cinemaIds, currentCinemaId)) {
                relevantMovies[movieId] = movie
            }
        }
    })

    if(customWeek) {
        customWeek.order.map(weekId => {
            const weekData = customWeek.items[weekId]
            const {startDate, endDate} = weekData

            const currentPeriodeStartDate = new Date(startDate)
            const currentPeriodeEndDate = new Date(endDate)

            sortedMovies = order.map((itemId, index) => {
                const movie = movieData[itemId]
                const moviePerformanceIds = movie.performances
        
                if(_.has(relevantMovies, itemId)) {
                    _.find(moviePerformanceIds, performanceId => {
                        const performance = performances[performanceId]
                        
                        const performanceUTC = performance.timeUtc
                        if((performance.cinemaId === currentCinemaId || multicinemaMode === MASTERMULTITOTAL || currentCinemaId === currentClientCinemaId) && currentPeriodeStartDate.getTime() < (performanceUTC + 30*60000) && (performanceUTC + 30*60000) < (currentPeriodeEndDate.getTime() + 30*60000)) {
                            if(!_.contains(currentMovies, itemId)) {    
                                currentMovies.push(itemId)
                            }
                        } 
                    })
                    
                    if(!_.contains(currentMovies, itemId) && !_.contains(futureMovies, itemId)) {
                        futureMovies.push(itemId)
                    }
                }
                
            })
        })
    } else {
        const year = new Date().getFullYear()
        const currentWeek = new Date(year, 0, (1 + (activeWeek - 1) * 7));
    
        while (currentWeek.getDay() !== 4) {
            currentWeek.setDate(currentWeek.getDate() + 1);
        }
    
        const currentPeriodeStartDate = currentWeek
        const currentPeriodeEndDate = getPeriodeEndDate(currentPeriodeStartDate, 7)

        sortedMovies = order.map((itemId, index) => {
            const movie = movieData[itemId]
            const moviePerformanceIds = movie.performances
    
            if(_.has(relevantMovies, itemId)) {
                _.find(moviePerformanceIds, performanceId => {
                    const performance = performances[performanceId]
                    const performanceUTC = performance.timeUtc
                    if((performance.cinemaId === currentCinemaId || multicinemaMode === MASTERMULTITOTAL || currentCinemaId === currentClientCinemaId) && currentPeriodeStartDate.getTime() < (performanceUTC + 30*60000) && (performanceUTC + 30*60000) < (currentPeriodeEndDate.getTime() + 30*60000)) {
                        if(!_.contains(currentMovies, itemId)) {    
                            currentMovies.push(itemId)
                        }
                    } 
                })
                
                if(!_.contains(currentMovies, itemId)) {
                    futureMovies.push(itemId)
                }
            }
            
        })
    }
    
    return sortedMovies       
}
export default getMoviesSortedAfterCurrentAndFuture